import { IFormFieldError } from '@thinknimble/tn-forms'
import { parseBackendErrors } from 'src/utils/errors'

/**
 * Field errors from a template create/update/submit 400, keyed by camelCased
 * field (`body`, `variableBindings`, `name`, `language`) so the modal can show
 * each one inline under its field.
 */
export type TemplateServerErrors = Record<string, string[]>

export const templateServerErrors = (error: unknown): TemplateServerErrors =>
  parseBackendErrors(error).fieldErrors

/** Adapts server messages to the `ErrorsList` shape. */
export const toFieldErrors = (messages?: string[]): IFormFieldError[] =>
  (messages ?? []).map((message) => ({ code: 'server', message }))
